module.exports = __webpack_public_path__ + "static/media/calendar.c956bb10.svg";